export const type = {
  guest: 'Visitante',
  provider: 'Prestador',
  others: 'Outros'
}

export const getOptionsStatus = () => {
  return Object.keys(type).map((key) => {
    return {
      id: key,
      label: type[key]
    }
  })
}



// WEBPACK FOOTER //
// ./src/app/dweller/visitor/index/resources/dataType.js